import { createContext, useContext } from 'react';

const initialValue = {
  isMultiPackage: undefined,
  trackingStatus: undefined,
  shipFrom: undefined,
  weight: undefined,
  dimensions: undefined,
  packageType: undefined,
  confirmation: undefined,
  insurance: undefined,
  packageContentDescription: undefined,
  isPackageDescriptionRequired: undefined,
  prepaidDutyAndPrice: undefined,
};

export const FulfillmentDisplayContext = createContext(initialValue);

export const useFulfillmentDisplayContext = () => useContext(FulfillmentDisplayContext);
